import React from 'react';

import {
    Text,
} from '@zillow/constellation';

import './style.scss';

const ActionMessageBox = ({
    children,
    logoType = 'buildings',
} = {}) => (
    <div className="ActionMessageBox">
        <div className="ActionMessageBox-icon-container">
            <div className={`ActionMessageBox-icon ActionMessageBox-${logoType}-icon`} />
        </div>

        <div className="ActionMessageBox-content">
            <Text>
                {children}
            </Text>
        </div>

    </div>
);

export default ActionMessageBox;
